"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ListingTypeByBrowseContext = void 0;
var _listingType = _interopRequireDefault(require("./listing-type"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var BrowseContext = {
  [_listingType.default.SALES_RESIDENTIAL.name]: 'browse-sale',
  [_listingType.default.RENTAL_RESIDENTIAL.name]: 'browse-rent',
  [_listingType.default.RENTAL_COMMERCIAL.name]: 'browse-commercial-rent',
  [_listingType.default.SALES_COMMERCIAL.name]: 'browse-commercial-sale',
  [_listingType.default.SALES_BUSINESS.name]: 'browse-business',
  [_listingType.default.SHARE_RESIDENTIAL.name]: 'browse-share',
  [_listingType.default.DEVELOPMENTS_RESIDENTIAL.name]: 'browse-new-homes',
  [_listingType.default.OFF_MARKET.name]: null,
  [_listingType.default.SALES_EARLY_ACCESS.name]: null
};
var ListingTypeByBrowseContext = exports.ListingTypeByBrowseContext = Object.keys(BrowseContext).reduce((map, listingTypeKey) => {
  var key = BrowseContext[listingTypeKey];
  if (key != null) {
    map[key] = listingTypeKey;
  }
  return map;
}, {});
var _default = exports.default = BrowseContext;